import React, { useState } from "react";
import ModalCrudCompany2 from "../../Components/company-form/ModalCrudCompany2";
import CompamyEdit from "../../Components/task/CompanyEdit";
import WaitingCompany from "../../Components/task/WaitingCompany";

const Task = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <main className="content">
      <div className="container-fluid p-0">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h1 className="h3 mb-3">ตรวจสอบบริษัท</h1>
          <div className="btn btn-info" onClick={() => setIsOpenModal(true)}>
            เพิ่มสถานประกอบการ
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-6">
            <WaitingCompany />
          </div>
          <div className="col-12 col-lg-6">
            <CompamyEdit />
          </div>
        </div>
      </div>

      <ModalCrudCompany2 setIsOpen={setIsOpenModal} modalIsOpen={isOpenModal} />
    </main>
  );
};

export default Task;
